import React from 'react';
import PropTypes from 'prop-types';

import {SVGIcon} from '@homeaway/react-svg';

// SVGIcon.whyDidYouRender = true;

import {useComponent} from './hooks';

import './SearchIcon.less';

function SearchIcon(props) {
    const {
        className,
        smallIconClassName,
        largeIconClassName,
        smallIconMarkup,
        largeIconMarkup
    } = useComponent(props);

    return (
        <span className={className}>
            <SVGIcon
                className={smallIconClassName}
                markup={smallIconMarkup}
            />
            <SVGIcon
                className={largeIconClassName}
                markup={largeIconMarkup}
            />
        </span>
    );
}

SearchIcon.propTypes = {
    iconName: PropTypes.string.isRequired
};

SearchIcon.whyDidYouRender = true;

export {SearchIcon};
